export default {"src":"/_next/static/media/american_express_icon.04a2871c.svg","height":128,"width":156,"blurWidth":0,"blurHeight":0};